module.exports = __webpack_public_path__ + "img/P150T_weapon_39.5bca26d9.png";